import { ref, watch, computed } from '@vue/composition-api'
import {
  isWithinInterval, parseISO, endOfDay, startOfDay,
} from 'date-fns'
import DatePicker from '@/components/DatePicker/DatePicker'
import ExternalConnectBtn from '@/components/@ui/ExternalConnectBtn'
import LinkDecorated from '@/components/@ui/LinkDecorated'
import SubscriptionPopup from './components/SubscriptionPopup/SubscriptionPopup'

import useForm from '@/compositions/useForm'
import useRequest from '@/compositions/useRequest'


export default {
  props: {
    value: Boolean,
    orderId: String,
    orderSlug: String,
    reportParams: Object,
    reports: Array,
    orderDates: Array,
  },
  components: {
    DatePicker, ExternalConnectBtn, SubscriptionPopup, LinkDecorated,
  },
  setup(props, context) {
    const { $store } = context.root
    const showSubscription = ref(null)
    const selected = ref([])
    const reportsArray = ref(props.reports)
    const typeReport = ref([])

    const typesReport = ['PDF', 'Excel']

    const { makeRequest: createReport, loading: createReportLoading } = useRequest({
      context,
      successMessage: 'Подписка на очет успешно создана!',
      request: data => $store.dispatch('orders/createReport', data),
    })

    const { validate, $errors, formData } = useForm({
      fields: {
        date: { default: [] },
      },
    })

    const prepareParams = () => {
      const params = {}
      const date = formData.date.value
      if (date[0]) {
        // eslint-disable-next-line prefer-destructuring
        params.start_date = date[0]
        if (date && date[1]) {
          // eslint-disable-next-line prefer-destructuring
          params.end_date = date[1]
        } else {
          // eslint-disable-next-line prefer-destructuring
          params.end_date = date[0]
        }
      }
      params.flags = selected.value
      return params
    }

    const generatePdfLink = () => {
      const paramsObj = prepareParams()
      let params = ''
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const [key, value] of Object.entries(paramsObj)) {
        if (params !== '') {
          params += '&'
        }
        params += `${key}=${encodeURIComponent(value)}`
      }
      return `${process.env.VUE_APP_API_URL}/cabinet/orders/${props.orderSlug}/export/pdf?${params}`
    }

    const generateExcellLink = () => {
      const paramsObj = prepareParams()
      let params = ''
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const [key, value] of Object.entries(paramsObj)) {
        if (params !== '') {
          params += '&'
        }
        params += `${key}=${encodeURIComponent(value)}`
      }
      return `${process.env.VUE_APP_API_URL}/cabinet/orders/${props.orderSlug}/export/excell?${params}`
    }

    const generateReportLink = () => {
      let url = ''
      if (typeReport.value === 'PDF') {
        url = generatePdfLink()
      }
      if (typeReport.value === 'Excel') {
        url = generateExcellLink()
      }
      return url
    }

    const submitSubscription = async (data) => {
      const obj = data
      obj.flags = selected.value
      const response = await createReport({ id: props.orderId, data: obj })
      reportsArray.value = response.reports
    }

    const getPdf = () => {
      window.open(generateReportLink())
    }

    const links = {
      mail: () => `mailto:?subject=Отчет по заказу&body=${generateReportLink()}`,
      telegram: () => `https://telegram.me/share/url?url=${generateReportLink()}`,
      viber: () => `viber://forward?text=${generateReportLink()}`,
      whatsapp: () => `https://api.whatsapp.com/send?text=${generateReportLink()}`,
    }

    const isValidReportDate = computed(() => {
      const date = new Date()
      const orderDateTimeStart = parseISO(props.orderDates[0])
      const orderDateTimeEnd = parseISO(props.orderDates[1])
      return isWithinInterval(date, {
        start: startOfDay(orderDateTimeStart),
        end: endOfDay(orderDateTimeEnd),
      })
    })

    watch(() => typeReport, () => {
      generateReportLink()
    }, { immediate: true })

    return {
      validate,
      $errors,
      formData,
      links,
      selected,
      createReportLoading,
      showSubscription,
      reportsArray,
      console,
      typesReport,
      typeReport,
      isValidReportDate,
      getPdf,
      submitSubscription,
    }
  },
}
